<div fxLayout="column">
  <div fxLayout="row" *ngIf="!inner">
    <h2 i18n>Emails</h2>
  </div>

  <div fxLayout="row">
    <mod-email-accordion fxFlex="100" *ngIf="emails" [issue]="issue" [isShowHeader]="false" [isShowColumnHeader]="true" [isAllowCreate]="authGuard.hasAnyAuthority(superRoles)" [isAllowDelete]="authGuard.hasAnyAuthority(superRoles)" [isAllowEdit]="authGuard.hasAnyAuthority(superRoles)" [isAllowLink]="false" [emails]="emails" (onEmailsModified)="fetch()"></mod-email-accordion>
  </div>
</div>
